import 'core-js'
import 'whatwg-fetch'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
// Order matters: AbortController needs fetch which needs Promise (provided by core-js).
import 'md-gum-polyfill'

import Uppy from '@uppy/core'
import Transloadit from '@uppy/transloadit'
import Dashboard from '@uppy/dashboard'
import { registerStereoAudioPreProcessor } from '../shared/stereo_audio_preprocessor'
import {
    AUDIO_ALLOWED_FILE_TYPES,
    AUDIO_ALLOWED_FILE_TYPES_MESSAGE
} from '../shared/audio_upload_options'
import { getEpisodeAudioChannelValidationOptions } from "../shared/episode_audio_channel_validation_options";
import {
    getEpisodeNumberValidationError,
    isEpisodeNumberValidationMessage,
    isRichTextBlank
} from "./shared/audio_episode_form_validation";

import { checkProcessingWarning, convertProcessingToDraft, cancelProcessingWarning } from "./shared/processing_warning_utils"

require('@uppy/core/dist/style.min.css')
require('@uppy/dashboard/dist/style.min.css')

document.addEventListener('alpine:init', () => {

    Alpine.data('edit_episode_x_data', () => ({
        init() {
            uppy_episode_audio(this)
            uppy_cover_art(this)
            externalJS(this)
            this.set_data()
            checkProcessingWarning(this)
        },
        audio_upload: false,
        cover_art_upload: false,
        cover_art_error_msg: "",
        save_text: "Update Episode",
        audio_error: "",
        title_error: "",
        description_error: "",
        season_error: "",
        episode_number_error: "",
        episode_errors: [],
        schedule_error: "",
        original_audio_file_name: "",
        audio_file_name: "",
        draft_text: "Save as Draft",
        background_upload_text: "",
        replace_audio_clicked: false,
        keyword_exists: false,
        contributor_exists: false,
        audio_assembly_id: "",
        cover_art_assembly_id: "",
        original_pub_date: "",
        pub_date_error: "",
        show_hide_from_feed_modal: false,
        show_appear_on_rss_feed_modal: false,
        download_audio_fn: null,
        // Processing warning modal state
        processing_warning_modal: false,
        is_converting_to_draft: false,
        set_data() {
            const dataEl = document.getElementById('ql-data-points')
            const cover_art_url = dataEl.dataset.coverArtUrl;
            const scheduled_time = dataEl.dataset.scheduledTime
            const audio_file_name = dataEl.dataset.audioFileName
            const isPublished = dataEl.dataset.isPublished === "true"
            const isScheduled = dataEl.dataset.isScheduled === "true"

            this.set_audio_data()

            if (cover_art_url !== "") {
                document.querySelector("#new_cover_art").src = cover_art_url
                document.querySelector("#episode_cover_art_assembly_id").value = dataEl.dataset.coverArtId
                this.cover_art_upload = true
            }

            if (scheduled_time !== "" && isScheduled && !isPublished) {
                document.querySelector("#ql-schedule-later").checked = true
                document.querySelector("#app_episode_scheduled_at_time").value = scheduled_time
                document.querySelector("#ql-schedule-section").classList.remove("hidden")
            }

            if (audio_file_name !== "") {
                this.original_audio_file_name = audio_file_name
                this.audio_file_name = audio_file_name
            }
            this.original_pub_date = dataEl.dataset.pubDate
        },
        set_audio_data() {
            const dataEl = document.getElementById('ql-data-points')
            const audio_url = dataEl.dataset.enclosureUrl;
            if (audio_url !== "") {
                let audio_div = document.getElementById('ql-uploaded-audio-insert')
                // create an event listener to enable us download audio cross-origin audio files
                this.download_audio_fn = downloadAudioHandler(audio_url, dataEl.dataset.audioFileName)
                document.getElementById('download-audio-btn').addEventListener('click', this.download_audio_fn);
                audio_div.setAttribute('src', audio_url)
                document.querySelector("#audio_assembly_id").value = dataEl.dataset.audioId
                audio_div.load()
                handleAudioDuration();
                this.audio_upload = true
            }
        },
        handle_hide_from_rss_feed_checkbox_clicked(target_element) {
            target_element.preventDefault()
            if (target_element.target.checked) {
                this.show_hide_from_feed_modal = true
            } else {
                this.show_appear_on_rss_feed_modal = true
            }
        },
        handle_hide_from_rss_feed_confirm() {
            document.querySelector("#app_episode_hide_from_feed").checked = true
            this.show_hide_from_feed_modal = false
        },
        handle_appear_on_rss_feed_confirm() {
            document.querySelector("#app_episode_hide_from_feed").checked = false
            this.show_appear_on_rss_feed_modal = false
        },
        convert_processing_to_draft() {
            convertProcessingToDraft(this);
        },
        cancel_processing_warning() {
            cancelProcessingWarning();
        },
        has_valid_inputs(type) {
            if (type == "") {
                return false
            }

            const titleField = document.querySelector("#app_episode_title")
            const audioField = document.querySelector("#audio_assembly_id")
            const descriptionField = document.querySelector("#app_episode_description")
            const episodeField = document.querySelector("#episode_number")
            const scheduleField = document.querySelector("#app_episode_scheduled_at_time")
            const scheduleLaterField = document.querySelector("#ql-schedule-later")
            const pubDateField = document.querySelector("#app_episode_pub_date")
            const episodeNumberError = getEpisodeNumberValidationError(episodeField?.value)

            let found_error = false

            this.description_error = ""
            if (isEpisodeNumberValidationMessage(this.episode_number_error)) {
                this.episode_number_error = ""
            }

            if (type == "draft") {
                console.log(titleField.value == "")
                if (titleField.value == "") {
                    this.title_error = "Please enter a title"
                    titleField.scrollIntoView({behavior: "smooth", block: "center"})
                    found_error = true
                }
            } else if (type == "submit") {
                if (titleField.value == "") {
                    this.title_error = "Please enter a title"
                    found_error = true
                    titleField.scrollIntoView({behavior: "smooth", block: "center"})
                } else if (audioField.value == "") {
                    this.audio_error = "Please upload an audio file"
                    found_error = true
                    document.querySelector("#audio_section").scrollIntoView({behavior: "smooth", block: "center"})
                } else if (scheduleLaterField.checked && scheduleField.value == "") {
                    this.schedule_error = "Please select a date to schedule your episode."
                    scheduleField.scrollIntoView({behavior: "smooth", block: "center"})
                    found_error = true
                } else if (isRichTextBlank(descriptionField?.value)) {
                    this.description_error = "Please enter a description"
                    document.querySelector(".ql-editor").scrollIntoView({behavior: "smooth", block: "center"})
                    found_error = true
                } else if (document.getElementById('ql-data-points').dataset.isPublished === "true" && pubDateField.value == "") {
                    // Basically just takes out the seconds and timezone
                    // const dateString = "2024-02-28 13:10:14 UTC";
                    //
                    // const [datePart, timePart] = dateString.split(' ');
                    // const [year, month, day] = datePart.split('-');
                    // const [hours, minutes] = timePart.split(':');
                    //
                    // const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
                    document.querySelector("#app_episode_pub_date")._flatpickr.setDate(this.original_pub_date)

                    this.pub_date_error = `Publication date cannot be empty or we will reset it to the original update. Please choose a publication date.`
                    pubDateField.scrollIntoView({behavior: "smooth", block: "center"})
                    found_error = true
                }
            }

            if (episodeNumberError !== "") {
                this.episode_number_error = episodeNumberError
                episodeField?.scrollIntoView({behavior: "smooth", block: "center"})
                found_error = true
            }

            if (found_error) {
                return false
            } else {
                return true
            }
        },
        handle_submit() {
            const that = this;
            const form = document.querySelector(".edit_app_episode")
            const data = new FormData(form);
            const submitData = new URLSearchParams(data);
            let submit_type;

            // These checks are for the case when we're updating a draft episode with the update button rather than draft button
            if (document.querySelector("#ql-schedule-now").checked || document.querySelector("#ql-schedule-later").checked) {
                submit_type = "submit"
            } else {
                submit_type = "draft"
                submitData.append("app_episode[is_draft]", "true");
            }

            if (this.has_valid_inputs(submit_type)) {
                if (submit_type == "draft") {
                    this.save_text = "Updating Episode..."
                } else {
                    if (submitData.get("app_episode[publish_now]") === "true") {
                        this.save_text = "Publishing Episode...";
                    } else {
                        this.save_text = "Scheduling Episode...";
                    }
                }

                submitData.append("app_episode[audio_file_name]", that.audio_file_name);
                (async () => {
                    const rawResponse = await fetch(form.action, {
                        method: 'PATCH',
                        body: submitData
                    });
                    const response = await rawResponse.json();

                    if (response.status === "success") {
                        window.location.href = response.link;
                    } else if (response.status === "error") {
                        that.episode_errors = response.reason
                        if (submitData.get("app_episode[publish_now]") === "true") {
                            that.save_text = "Publish";
                        } else {
                            that.save_text = "Schedule";
                        }
                        that.$refs.episode_errors.scrollIntoView({behavior: "smooth", block: "center"})
                    }
                })();
            } else {
                document.querySelector(".ql-submit").classList.add("border-red-400")
            }
        },
        handle_draft() {
            const that = this;
            const form = document.querySelector(".edit_app_episode")
            const data = new FormData(form);
            const submitData = new URLSearchParams(data);
            console.log("HI");
            console.log(this.has_valid_inputs("draft"))
            if (this.has_valid_inputs("draft")) {
                submitData.append("app_episode[is_draft]", "true");
                submitData.append("app_episode[audio_file_name]", that.audio_file_name);
                this.draft_text = "Saving...";
                (async () => {
                    const rawResponse = await fetch(form.action, {
                        method: 'PATCH',
                        body: submitData
                    });
                    const response = await rawResponse.json();

                    if (response.status === "success") {
                        window.location.href = response.link;
                    } else if (response.status === "error") {
                        that.episode_errors = response.reason
                        this.draft_text = "Save as Draft";
                        that.$refs.episode_errors.scrollIntoView({behavior: "smooth", block: "center"})
                    }
                })();
            } else {
                document.querySelector(".ql-submit-draft").classList.add("border-red-400")
            }
        },
        check_if_audio_uploaded() {
            let that = this;
            // Audio has been properly uploaded, do nothing
            if (this.audio_upload === true) {
                return
            }

            (async () => {
                const rawResponse = await fetch(`https://api2.transloadit.com/assemblies/${that.audio_assembly_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const content = await rawResponse.json();

                if (content.ok === "ASSEMBLY_UPLOADING" || content.ok === "ASSEMBLY_EXECUTING") {
                    that.send_upload_error_notification(that.audio_assembly_id)
                }

            })();
        },
        check_if_cover_art_uploaded() {
            let that = this;
            // Audio has been properly uploaded, do nothing
            if (this.cover_art_upload === true) {
                return
            }

            (async () => {
                const rawResponse = await fetch(`https://api2.transloadit.com/assemblies/${that.cover_art_assembly_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const content = await rawResponse.json();

                if (content.ok === "ASSEMBLY_UPLOADING" || content.ok === "ASSEMBLY_EXECUTING") {
                    that.send_upload_error_notification(that.cover_art_assembly_id)
                }

            })();
        },
        send_upload_error_notification(assembly_id) {
            (async () => {
                const rawResponse = await fetch(document.getElementById('ql-data-points').dataset.uploadErrorNotifyUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                        assembly_id: assembly_id
                    })
                });
                const content = await rawResponse.json();
            })();
        },
        handle_duplicate_check(event) {
            let that = this
            const fieldValue = parseInt(event.target.value);

            const episodeSeason = document.getElementById('episode_season').value
            const episodeNumber = document.getElementById('episode_number').value

            if (episodeSeason && episodeNumber) {
                const episodeId = document.getElementById('ql-data-points').dataset.episodeId
                const checkDuplicateUrl = `${document.getElementById('ql-data-points').dataset.checkDuplicateUrl}?id=${episodeId}&episode_season=${episodeSeason}&episode_number=${fieldValue}`
                fetch(checkDuplicateUrl)
                    .then(response => response.json())
                    .then(data => {
                        console.log({data})
                        const {duplicate, episode_title} = data
                        if (duplicate) {
                            that.episode_number_error = `Please note, the episode titled: '${episode_title}' already has this season (${episodeSeason}) and episode number (${episodeNumber})`
                        } else {
                            that.episode_number_error = ''
                        }
                    })

            } else {
                that.episode_number_error = ''
            }
        },
        go_to_settings_page() {
            const dataEl = document.getElementById("ql-data-points");
            const showId = dataEl.dataset.showId;
            const settingsPage = `/shows/${showId}/distribution/show-settings#cover-art-section`
            const titleField = document.querySelector("#app_episode_title")
            if (titleField.value === '') {
                document.location.href = settingsPage
                return
            }

            const that = this
            const form = document.querySelector(".edit_app_episode")
            const data = new FormData(form);
            const submitData = new URLSearchParams(data);
            submitData.append("app_episode[is_draft]", "true");
            submitData.append("app_episode[audio_file_name]", that.audio_file_name);
            this.draft_text = "Saving...";
            (async () => {
                const rawResponse = await fetch(form.action, {
                    method: 'PATCH',
                    body: submitData
                });
                const response = await rawResponse.json();
                if (response.status === "success") {
                    setTimeout(function () {
                        document.location.href = settingsPage
                    }, 250);
                } else if (response.status === "error") {
                    that.episode_errors = response.reason
                    this.draft_text = "Save as Draft";
                    that.$refs.episode_errors.scrollIntoView({behavior: "smooth", block: "center"})
                }
            })();
        }
    }))
})

// helper function that allows us download cross-origin audio files as blob
function downloadAudioHandler(url, fileName) {
    return function (event) {
        event.preventDefault();
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                const link = document.createElement('a');
                const blobUrl = URL.createObjectURL(blob);
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            })
            .catch(error => console.error('There was an error with the download:', error));
    };
}

function uppy_cover_art(alpine) {
    let signature = document.getElementById('ql-data-points').dataset.signature
    let template_episode_cover_art_id = document.getElementById('ql-data-points').dataset.templateEpisodeCoverArt

    const uppy = new Uppy({
        id: 'uppy_cover_art',
        debug: true,
        autoProceed: true,
        allowMultipleUploadBatches: false,
        restrictions: {
            maxFileSize: 2 * 1024 * 1024,
            minFileSize: 1,
            maxTotalFileSize: 2 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ['image/*'],
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: 'You can only upload image files',
            },
        },
    })


    uppy.use(Dashboard, {
        trigger: document.getElementById('episode-cover-art-uppy-trigger'),
        showProgressDetails: true,
        note: 'Image must be exactly 3000px by 3000px.'
    })

    // Validate image dimensions using Uppy's file-added event
    uppy.on('file-added', (file) => {
        // Only validate image files
        if (!file.type || !file.type.startsWith('image/')) {
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file.data);

        reader.onload = () => {
            const img = new Image();

            img.onload = () => {
                // Validate dimensions - must be exactly 3000x3000
                if (img.width !== 3000 || img.height !== 3000) {
                    // Remove the invalid file
                    uppy.removeFile(file.id);

                    // Set user-friendly error message with actual dimensions
                    alpine.cover_art_error_msg = `You've uploaded an image that is ${img.width}x${img.height}px. We only accept images that are 3000x3000px.`;

                    // Close the modal
                    setTimeout(() => {
                        uppy.getPlugin('Dashboard').closeModal();
                    }, 100);
                } else {
                    // Clear error if dimensions are valid
                    alpine.cover_art_error_msg = "";
                }
            };

            img.onerror = () => {
                uppy.removeFile(file.id);
                alpine.cover_art_error_msg = "Unable to validate image dimensions. Please try a different image.";
                setTimeout(() => {
                    uppy.getPlugin('Dashboard').closeModal();
                }, 100);
            };

            img.src = reader.result;
        };

        reader.onerror = () => {
            uppy.removeFile(file.id);
            alpine.cover_art_error_msg = "Unable to read the image file. Please try again.";
            setTimeout(() => {
                uppy.getPlugin('Dashboard').closeModal();
            }, 100);
        };
    });

    uppy.use(Transloadit, {
        service: 'https://api2.transloadit.com',
        params: {
            auth: {
                key: signature,
            },
            template_id: template_episode_cover_art_id
        },
        waitForEncoding: true,
        waitForMetadata: true,
        importFromUploadURLs: false,
        alwaysRunAssembly: false,
    })

    uppy.on('upload-error', (file, error, response) => {
        if (error.isNetworkError) {
            alert("The audio file was not uploading\n\n" +
                "If you are uploading from an office network, please check with your IT department regarding firewall settings. \n\n" +
                "Error: " + error.message)
        } else {
            alpine.cover_art_error_msg = error.toString()
        }
    })

    uppy.on('transloadit:assembly-created', (assembly, fileIDs) => {
        alpine.cover_art_assembly_id = assembly.assembly_id
    });

    uppy.on('transloadit:assembly-executing', (assembly) => {
        setTimeout(function () {
            alpine.check_if_cover_art_uploaded();
        }, 60000);
    });

    uppy.on('complete', (result) => {
        result.successful.forEach(file => {
            console.log(file)
            console.log(file.response)
            document.querySelector("#new_cover_art").src = file.response.uploadURL
            document.querySelector("#episode_cover_art_assembly_id").value = file.transloadit.assembly
            alpine.cover_art_upload = true
        })
        uppy.cancelAll()
        uppy.getPlugin('Dashboard').closeModal()
    })
}

function uppy_episode_audio(alpine) {
    let signature = document.getElementById('ql-data-points').dataset.signature
    let template_id = document.getElementById('ql-data-points').dataset.template
    const dataEl = document.getElementById("ql-data-points");
    const channelValidationOptions = getEpisodeAudioChannelValidationOptions(dataEl);

    const uppy = new Uppy({
        id: 'uppy_episode_audio',
        debug: true,
        autoProceed: true,
        restrictions: {
            maxFileSize: 300 * 1024 * 1024,
            minFileSize: 300 * 1024,
            maxTotalFileSize: 300 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: AUDIO_ALLOWED_FILE_TYPES,
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: AUDIO_ALLOWED_FILE_TYPES_MESSAGE,
            },
        },
    })

    // Preprocessor blocks autoProceed uploads until async stereo validation completes.
    registerStereoAudioPreProcessor(uppy, channelValidationOptions)


    uppy.use(Dashboard, {
        trigger: document.getElementById('content-uppy-trigger'),
        closeAfterFinish: true,
        showProgressDetails: true,
        note: 'Audio files should be 150 MB or less.'
    })

    uppy.use(Transloadit, {
        service: 'https://api2.transloadit.com',
        params: {
            auth: {
                key: signature,
            },
            template_id: template_id
        },
        waitForEncoding: true,
        waitForMetadata: true,
        importFromUploadURLs: false,
        alwaysRunAssembly: false,
    })

    uppy.on('upload', (data) => {
        alpine.background_upload_text = "Your audio is continuing to upload. To cancel, select Upload and click the X in the bottom right corner."
    })

    uppy.on('transloadit:assembly-created', (assembly, fileIDs) => {
        console.log("Assembly Created:", assembly.assembly_id)
        alpine.audio_assembly_id = assembly.assembly_id
    });

    uppy.on('transloadit:assembly-executing', (assembly) => {
        console.log("Calling Function Created:", assembly.assembly_id)
        setTimeout(function () {
            alpine.check_if_audio_uploaded();
        }, 180000);
    });

    uppy.on('upload-error', (file, error, response) => {
        if (error.isNetworkError) {
            alert("The audio file was not uploading\n\n" +
                "If you are uploading from an office network, please check with your IT department regarding firewall settings. \n\n" +
                "Error: " + error.message)
        } else {
            // alert("The audio file was not uploaded\n\n" + "Please check your internet connection and try again")
        }
        console.log("error", error.toString())
        console.log("response", response)
    })

    uppy.on('complete', (result) => {
        result.successful.forEach(file => {
            console.log(file)
            console.log(file.response)
            let audio_div = document.getElementById('ql-uploaded-audio-insert')
            audio_div.setAttribute('src', file.response.uploadURL)
            // remove the event listener to enable us download newly uploaded audio files
            document.getElementById('download-audio-btn').removeEventListener('click', alpine.download_audio_fn);
            const downloadLink = document.getElementById('download-audio-btn')
            downloadLink.href = file.response.uploadURL
            downloadLink.download = file.name
            document.querySelector("#audio_assembly_id").value = file.transloadit.assembly
            audio_div.load()
            handleAudioDuration();
            if (alpine.replace_audio_clicked) {
                alpine.replace_audio_clicked = false
            }
            alpine.audio_file_name = file.name
            alpine.background_upload_text = ""
            alpine.audio_upload = true
        })
        uppy.cancelAll()
        uppy.getPlugin('Dashboard').closeModal()
    })
}

function handleAudioDuration() {
    const audio_div = document.getElementById('ql-uploaded-audio-insert')
    const time_div = document.getElementById('audio-play-time')
    audio_div.addEventListener("loadedmetadata", () => {
        console.log(audio_div.duration)
        time_div.innerHTML = "00:00/" + convertSeconds(audio_div.duration)
    })
    audio_div.addEventListener("timeupdate", () => {
        time_div.innerHTML = convertSeconds(audio_div.currentTime) + '/' + convertSeconds(audio_div.duration);
    })
}

function convertSeconds(seconds) {
    if (seconds >= 3600) {
        return new Date(seconds * 1000).toISOString().slice(11, 19);
    } else {
        return new Date(seconds * 1000).toISOString().slice(14, 19);
    }
}

function loadScript(url, callback) {
    let script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) {  //IE
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" ||
                script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

function externalJS(alpine) {
    loadScript("https://cdn.jsdelivr.net/npm/tom-select@1.7.6/dist/js/tom-select.complete.min.js", function () {
        new TomSelect("#app_episode_keywords", {
            plugins: {
                remove_button: {
                    title: 'Remove this tag',
                }
            },
            persist: false,
            create: true,
            createOnBlur: true,
            render: {
                no_results: null
            },
            createFilter: function (input) {
                const exists = (input in this.options);
                if (exists) {
                    alpine.keyword_exists = true
                } else {
                    alpine.keyword_exists = false
                }
                return !exists
            },
            onBlur: function () {
                alpine.keyword_exists = false
            }
        });

        new TomSelect("#app_episode_contributors", {
            plugins: {
                remove_button: {
                    title: 'Remove this tag',
                }
            },
            persist: false,
            create: true,
            createOnBlur: true,
            render: {
                no_results: null
            },
            createFilter: function (input) {
                const exists = (input in this.options);
                if (exists) {
                    alpine.contributor_exists = true
                } else {
                    alpine.contributor_exists = false
                }
                return !exists
            },
            onBlur: function () {
                alpine.contributor_exists = false
            }
        })
    })

    const scheduleField = document.querySelector("#app_episode_scheduled_at_time")
    if (!scheduleField.dataset.episodeSchedulePicker) {
        flatpickr(scheduleField, {enableTime: true, minDate: Date.now()});
    }
    if (document.getElementById('ql-data-points').dataset.isPublished === "true") {
        const publicationDateField = document.querySelector("#app_episode_pub_date")
        if (!publicationDateField.dataset.episodeSchedulePicker) {
            flatpickr(publicationDateField, {
                enableTime: true,
                defaultDate: document.getElementById('ql-data-points').dataset.pubDate,
                maxDate: Date.now()
            });
        }
    }

    const scheduleSection = document.querySelector("#ql-schedule-section")

    document.querySelector("#ql-schedule-later").addEventListener("click", function () {
        scheduleSection.classList.remove("hidden")
    })

    document.querySelector("#ql-schedule-now").addEventListener("click", function () {
        scheduleSection.classList.add("hidden")
    })

    let toolbar_options = [
        ['bold', 'italic'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['link'],
        ['undo'],
        ['redo'],
        [{'direction': 'rtl'}],
        ['clean']
    ];

    let icons = Quill.import('ui/icons');
    icons["undo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
  </svg>`;
    icons["redo"] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
  </svg>`;

    Quill.register('modules/counter', function (quill, options) {
        let container = document.querySelector(options.container);
        quill.on('text-change', function () {
            let text = quill.getText();
            let words = text.split(/\s+/).length - 1;
            let characters = text.length - 1;

            if (characters > 4000) {
                container.innerHTML = `<span class="text-red-400 font-bold">Reached limit of ${characters} characters for Apple description cutoff</span>`;
            } else if (characters === 0) {
                container.innerHTML = "";
            } else {
                container.innerHTML = `${words} words, ${characters} characters`;
            }
        });
    });
// Initialize Quill editor
    let quill = new Quill('.ql-editor', {
        theme: 'snow',
        placeholder: 'Your episode description...',
        modules: {
            toolbar: {
                container: toolbar_options,
                handlers: {
                    undo: function (value) {
                        this.quill.history.undo();
                    },
                    redo: function (value) {
                        this.quill.history.redo();
                    },
                    'link': function (value) {
                        if (value) {
                            var href = prompt('Enter the URL', "https://");
                            this.quill.format('link', href);
                        } else {
                            this.quill.format('link', false);
                        }
                    }
                }
            },
            history: {
                delay: 2000,
                maxStack: 500,
                userOnly: true
            },
            counter: {
                container: '#counter'
            }
        }
    });


    let description = document.getElementById('app_episode_description');
    quill.root.innerHTML = description.value;

    quill.on('editor-change', function () {
        description.value = quill.root.innerHTML;
    });

    document.addEventListener('turbo:load load', function () {
        let description = document.getElementById('app_episode_description');
        console.log("description", description.value);
        quill.root.innerHTML = description.value;
    });
}
